import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface OrganizationUsersState {
  dataUser: any | null;
}

const initialState: OrganizationUsersState = {
  dataUser: null,
};

const organizationUsersSlice = createSlice({
  name: "organizationUsers",
  initialState,
  reducers: {
    getOrganizationUsersRequest(
      state,
      _action: PayloadAction<{
        orgId: string;
        page?: number;
        pageSize?: number;
      }>
    ) {},
    getOrganizationUsersSuccess(state, action: PayloadAction<any>) {
      state.dataUser = action.payload;
      //console.log("action.payload", action.payload);
    },
    getOrganizationUsersFailure(state, action: PayloadAction<string>) {},
  },
});

export const {
  getOrganizationUsersRequest,
  getOrganizationUsersSuccess,
  getOrganizationUsersFailure,
} = organizationUsersSlice.actions;

export default organizationUsersSlice.reducer;
